export enum TabsEnum {
  RECEPTIONIST = 'receptionist',
  DOCTOR = 'doctor',
  BILLING = 'billing',
  LOCAL = 'local-admin',
  SPECIALIST = 'specialist',
}
